// Port of api/fuel/app/classes/insights/size/overview.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'
import Config from 'offline/model/config'

function excludeExpansions(ownerId) {
	var config = Config.user(ownerId)
	return !!(((config || {}).insights || {}).size || {}).expansions
}

export default Segment.extend({
	name: 'overview',
	priority: 10,
	types: [Constants.TYPE_USER],
	insight: false,
	detail: false,
	requires: ['lifespan'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var exclude = excludeExpansions(vars && vars.sessionUserId)
		var fieldCount = exclude ? 'insight_count_base' : 'insight_count'
		var fieldAdded = exclude ? 'insight_count_base_added' : 'insight_count_added'
		var fieldRemoved = exclude ? 'insight_count_base_removed' : 'insight_count_removed'
		var overview = {
			added: 0,
			removed: 0,
			biggest: 0,
			increase: 0,
			decrease: 0,
			refresh: 0,
			lifetime: {
				average: 0,
				longest: 0,
				shortest: 0
			}
		}

		var addedResult = Util.queryFast(
			'SELECT COUNT(l.log_id) AS c FROM log_user_collection l' +
			(exclude ? ', game g' : '') +
			' WHERE l.log_context = ' + Constants.LOG_CONTEXT_ADDED +
			' AND l.user_id = ' + owner.get_id() +
			(exclude ? ' AND l.game_id = g.game_id AND g.game_type = 1' : '')
		)
		var removedResult = Util.queryFast(
			'SELECT COUNT(l.log_id) AS c FROM log_user_collection l' +
			(exclude ? ', game g' : '') +
			' WHERE l.log_context = ' + Constants.LOG_CONTEXT_REMOVED +
			' AND l.user_id = ' + owner.get_id() +
			(exclude ? ' AND l.game_id = g.game_id AND g.game_type = 1' : '')
		)
		overview.added = parseInt(addedResult[0].c, 10) || 0
		overview.removed = parseInt(removedResult[0].c, 10) || 0

		var biggest = Util.queryFast(
			'SELECT insight_date AS d, ' + fieldCount + ' AS v FROM insight_user_collection' +
			' WHERE user_id = ' + owner.get_id() +
			' ORDER BY ' + fieldCount + ' DESC LIMIT 1'
		)
		var increase = Util.queryFast(
			'SELECT insight_date AS d, ' + fieldAdded + ' AS v FROM insight_user_collection' +
			' WHERE user_id = ' + owner.get_id() + ' AND ' + fieldAdded + ' > 0' +
			' ORDER BY ' + fieldAdded + ' DESC LIMIT 1'
		)
		var decrease = Util.queryFast(
			'SELECT insight_date AS d, ' + fieldRemoved + ' AS v FROM insight_user_collection' +
			' WHERE user_id = ' + owner.get_id() + ' AND ' + fieldRemoved + ' > 0' +
			' ORDER BY ' + fieldRemoved + ' DESC LIMIT 1'
		)
		var refresh = Util.queryFast(
			'SELECT insight_date AS d, (' + fieldAdded + ' + ' + fieldRemoved + ') AS r FROM insight_user_collection' +
			' WHERE user_id = ' + owner.get_id() +
			' AND (' + fieldAdded + ' + ' + fieldRemoved + ') > 0' +
			' AND ((1.0 / (' + fieldAdded + ' + ' + fieldRemoved + ')) * ' + fieldAdded + ') >= 0.30' +
			' AND ((1.0 / (' + fieldAdded + ' + ' + fieldRemoved + ')) * ' + fieldAdded + ') <= 0.70' +
			' ORDER BY r DESC LIMIT 1'
		)

		if (biggest.length) overview.biggest = { value: parseInt(biggest[0].v, 10) || 0, date: parseInt(biggest[0].d, 10) || 0 }
		if (increase.length) overview.increase = { value: parseInt(increase[0].v, 10) || 0, date: parseInt(increase[0].d, 10) || 0 }
		if (decrease.length) overview.decrease = { value: parseInt(decrease[0].v, 10) || 0, date: parseInt(decrease[0].d, 10) || 0 }
		if (refresh.length) overview.refresh = { value: parseInt(refresh[0].r, 10) || 0, date: parseInt(refresh[0].d, 10) || 0 }

		var lifetime = (this._data.lifetime_overview || {})
		overview.lifetime = {
			average: lifetime.average || 0,
			longest: lifetime.longest || 0,
			shortest: lifetime.shortest || 0
		}

		return {
			overview: overview
		}
	}
})
